<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Operators</h4>
                </div>
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-button class="btn mb-4 md:mb-0 mr-1" icon="refresh" @click="fetchData">Refresh</vs-button>
                    <vs-button class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
                    <vs-button class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" @click="view" :disabled="!selectedId">View</vs-button>
                    <vs-button class="mb-4 md:mb-0 mr-1" icon="delete" @click="deleteData" :disabled="!selectedId">Delete</vs-button>
                    <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item>Template</vs-dropdown-item>
                            <vs-dropdown-item>Upload</vs-dropdown-item>
                                <input type="file" ref="file" style="display: none" />
                            <vs-dropdown-item >Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="view"
            ></ag-grid-vue>
            <p class="text-right">
                <strong>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</strong>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        </vx-card>
        <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
            <div class="con-exemple-prompt">
            <vs-input v-model="form.name" class="mb-2 w-full" label="Name" :disabled="!editMode"/>
            <vs-input v-model="form.notes" class="mb-2 w-full" label="Notes" :disabled="!editMode"/>
            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                <vs-button color="primary" class="mt-2 mr-2" @click="editMode = true">Edit</vs-button>
                <vs-button color="primary" class="mt-2" @click="saveData" :disabled="!editMode">Save</vs-button>
            </vs-row>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            data: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            editMode: false,
            form: {
                name: '',
                notes: ''
            },
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            showViewForm: false
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });

            this.selectedId = selectedRowsString;
        },
        fetchData() {
            this.selectedId = null;
            this.isLoading = true;

            this.$http.post(`master/operators?page=${this.currentPage}`, this.form)
            .then(res => {
                this.data = res.data.data;
                this.totalPage = res.data.last_page;
                this.currentPage = res.data.current_page;
                this.dataFrom = res.data.from;
                this.dataTo = res.data.to;
                this.dataTotal = res.data.total;
                this.isLoading = false;
            })
            .catch(e => this.handleError(e));
        },
        view() {
            this.editMode = false;
            this.isLoading = true;

            this.$http.get(`master/operators/${this.selectedId}`)
            .then(res => {
                this.form.name = res.data.name;
                this.form.notes = res.data.notes;
                this.isLoading = false;
                this.showViewForm = true;
            })
            .catch(e => this.handleError(e));
        },
        saveData() {
            this.isLoading = true;

            this.$http.post(`master/operators/${this.selectedId}/update`, this.form)
            .then(res => {
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: res.data.message || "Updated successfully"
                });

                this.showViewForm = false;
                this.isLoading = false;
                this.fetchData();
            })
            .catch(e => this.handleError(e));
        },
        deleteData() {
            this.isLoading = true;

            this.$http.delete(`master/operators/${this.selectedId}`)
            .then(res => {
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: res.data.message || "Updated successfully"
                });

                this.isLoading = false;
                this.fetchData();
            })
            .catch(e => this.handleError(e));
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Name",
                field: "name",
                width: 120,
            },
            {
                headerName: "Notes",
                field: "notes",
                width: 240
            }
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>